import { createApiQueryHook, IApiQueryFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { ISkillDomain, ISkillDomainResource } from "../types";

export interface ISkillDomainQueryParameters {
    skillDomain?: RelationalValue<ISkillDomainResource>;
}

export type ISkillDomainQueryResult = ISkillDomain;

export const skillDomainQuery: IApiQueryFunction<ISkillDomainQueryParameters> = ({ skillDomain }) => {
    if (!skillDomain) {
        return;
    }

    return {
        method: "GET",
        url: `/skill_domains/${mapRelationalValue(skillDomain)}`,
    };
};

export const useSkillDomainQuery = createApiQueryHook<ISkillDomainQueryParameters, ISkillDomainQueryResult>(
    skillDomainQuery,
);
